import { render, staticRenderFns } from "./FlightEventInfo.vue?vue&type=template&id=84165abe"
import script from "./FlightEventInfo.vue?vue&type=script&lang=js"
export * from "./FlightEventInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports